// A search over an employee's name and identifier, ignoring case and the
// order of the words, so "ortiz maria" finds "Maria Ortiz".
export function matchesEmployee(query: string, name: string, identifier: string): boolean {
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean)
  if (terms.length === 0) return true
  const haystack = `${name} ${identifier}`.toLowerCase()
  return terms.every((term) => haystack.includes(term))
}
